/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-expressions */
import {
    Dialog,
    FileSelector,
    FileSelectorMode,
    FileInfo,
} from '@eta/components';
import {
    IIconProps,
    initializeIcons,
    ActionButton,
    MessageBar,
    MessageBarType,
    Icon,
    Label,
    PrimaryButton,
    ProgressIndicator,
    Dialog as OriginalDialog,
} from '@fluentui/react';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx-color';
import { saveAs } from 'file-saver';
import moment from 'moment';
import './DeviceBulkUpload.scss';
import { Dates } from '../../../common/config/constants';
import { UIHelpers } from '../../../helpers/UIHelpers';
import { ServiceCreator } from '../../../Services/ClientProxy/ServiceFactory';
import {
    RejectedDeviceDto,
    CurrentDeviceDto,
    DeviceStatusDto,
    InvalidDeviceDto,
    DeviceKeyDto,
    DeviceKeyModel,
    ValidationError,
    CurrentRejectedDeviceDto,
} from '../../../Services/POS/PosService';
import { ResponseCurrentDeviceDto } from './BulkUploadModels';

initializeIcons((window as any).REACT_APP_Fabric_Icons_CDN);;
const playResume: IIconProps = { iconName: 'PlayResume' };
const cancelIcon: IIconProps = { iconName: 'Clear' };
const downloadIcon: IIconProps = { iconName: 'Download' };

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
interface IDeviceBulkUpload {
    hidden: boolean;
    onStartProcessing: (data: string, isHidden: boolean) => void;
}

export const DeviceBulkUpload: FC<IDeviceBulkUpload> = (
    props: IDeviceBulkUpload
) => {
    const { hidden, onStartProcessing } = props;
    const { t } = useTranslation(['DeviceBulkUpload', 'common']);
    const [, setErrors] = useState<any>(undefined);
    const [hiddenDialog, setHiddenDialog] = useState<boolean>(hidden);
    const [showInitialDialog, setshowInitialDialog] = useState<boolean>(true);
    const wsname = 'DataEntry';
    const [isValid, setisValid] = useState<boolean | undefined>(false);
    const EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const GetFileInfo = (): FileInfo => {
        const ExistingTempFile: FileInfo = { name: '', url: '' };

        ExistingTempFile.name = `${t(
            'DeviceBulkUpload:DevicesBulkTemplateName'
        )}.xlsx`;
        ExistingTempFile.url = `./${t(
            'DeviceBulkUpload:DevicesBulkTemplateName'
        )}.xlsx`;

        return ExistingTempFile;
    };
    const [existingTempFileInfo] = React.useState<FileInfo>(GetFileInfo());
    const [showProgress, setShowProgress] = React.useState<boolean>(false);
    const [invalidTemplateFile, setInvalidTemplateFile] =
        React.useState<boolean>(false);
    const [ErrorMessage, setErrorMessage] = useState<string | undefined>(
        undefined
    );
    const [devices, setDevices] = useState<CurrentDeviceDto[] | undefined>();
    const [rejectedDevices, setRejectedDevices] = useState<
        RejectedDeviceDto[] | undefined
    >([]);
    const [passedDevicesCount, setPassedDevicesCount] = useState<number>(0);
    const [systemConfiguration, setSystemConfiguration] = useState<
        boolean | undefined
    >();
    const GetRecordMaxNumber = () => {
        let maxRecordNum = 0;

        maxRecordNum = (window as any).REACT_APP_MaxDeviceBulkRowsNumber;

        return maxRecordNum;
    };
    const MaxRecordLen = GetRecordMaxNumber();
    const DateFormat = Dates.Date;
    const GetTitle = (): JSX.Element => {
        let Title: JSX.Element = <></>;
        Title = (
            <>
                <Icon iconName="BulkUpload" />
                <p>{t('DeviceBulkUpload:BulkRegistrationDeviceTitle')}</p>
            </>
        );
        return Title;
    };
    const GetDeviceStatus = (
        value: string | undefined
    ): DeviceStatusDto | undefined => {
        switch (value?.trim().replace(/\s/g, '').toLowerCase()) {
            case 'active':
                return DeviceStatusDto.Active;
            case 'inactive':
                return DeviceStatusDto.InActive;
            default:
                return undefined;
        }
    };
    const NormalizeString = (value: string | undefined): string | undefined => {
        if (value === undefined) return undefined;
        const text = value.toString().trim();
        if (text === '') return undefined;
        return text;
    };
    const GetDeviceBranchNum = (
        value: string | undefined
    ): number | undefined => {
        if (value === undefined || value === '') return undefined;
        const branchNum = +value;
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(branchNum)) return undefined;
        return branchNum;
    };
    /* const addDays = (
        date: Date | undefined,
        days: number
    ): Date | undefined => {
        if (!date) return undefined;
        if (!moment(date, DateFormat, true).isValid()) return undefined;

        date.setDate(date.getDate() + days);
        return date;
    }; */
    const IsInvalidDate = (date: any): boolean | undefined => {
        if (!date) return true;
        try {
            date.getTime();
            return false;
        } catch (ex) {
            return true;
        }
    };
    /*  const ConvertDateTOMMDDYYYY=(date: any): string=>{
        const today = new Date(date);
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
        const yyyy = today.getFullYear();

       return `${mm}/${dd}/${yyyy}`;
    }; */
    const GetDate=(date: any): Date|undefined=>{
        const isInvalid=IsInvalidDate(date);
         if(isInvalid===undefined)return undefined;
         if(isInvalid)return UIHelpers.AdjustDate(UIHelpers.getDateFormatted(date,DateFormat));
         const finaldate= UIHelpers.AdjustDate(date); // Fix Production Bug #90259
         // return UIHelpers.AdjustDate(addDays(date, 1)); Fix Production Bug #90259
        // const DateMMDDYYYY=ConvertDateTOMMDDYYYY(date);
       // const DateDDMMYYYY=UIHelpers.getDateFormatted(DateMMDDYYYY, DateFormat);
      // const finaldate= UIHelpers.AdjustDate(DateDDMMYYYY);
       return finaldate;

    };

    const MapDataToObj = (d: unknown) => {
        const data = d as unknown as Array<{}>;
        if (data.length > 0) {
            const templateColumnNum = Object.keys(data[0]).length;
            const deviceDtoObj = new CurrentDeviceDto();
            const deviceObjPropertyNum = Object.keys(deviceDtoObj).length;
            if (templateColumnNum > deviceObjPropertyNum + 1) {
                setInvalidTemplateFile(true);
                setshowInitialDialog(false);
                setisValid(false);
                return;
            }
            const DevicesDtoList: CurrentDeviceDto[] = [];
            data?.map((i: any) => {
                const headers = Object.keys(i);
                if (headers.length > 0) {
                    const device = new CurrentDeviceDto();
                    device.vendorName = NormalizeString(
                        i[t('DeviceBulkUpload:VendorNameHeader')] ?? ''
                    );
                    device.modelName = NormalizeString(
                        i[t('DeviceBulkUpload:ModelNameHeader')] ?? ''
                    );
                    device.name = NormalizeString(
                        i[t('DeviceBulkUpload:DeviceNameHeader')] ?? ''
                    );
                    device.description = NormalizeString(
                        i[t('DeviceBulkUpload:DescENHeader')] ?? ''
                    );
                    device.status = GetDeviceStatus(
                        i[t('DeviceBulkUpload:StatusHeader')] ?? ''
                    );
                    device.branchNumber = GetDeviceBranchNum(
                        i[t('DeviceBulkUpload:TaxpayerBranchHeader')] ?? ''
                    );
                    device.serialNumber = NormalizeString(
                        i[t('DeviceBulkUpload:SerialNumberHeader')] ?? ''
                    );
                    device.activeFrom = GetDate(
                        i[t('DeviceBulkUpload:ActiveFromHeader')]
                    );
                    device.activeTo = GetDate(
                        i[t('DeviceBulkUpload:ActiveToHeader')]
                    );

                    DevicesDtoList.push(device);
                }
            });
            if (data.length > 0 && DevicesDtoList.length === 0) {
                setInvalidTemplateFile(true);
                setshowInitialDialog(false);
                setisValid(false);
                return;
            }
            setDevices(DevicesDtoList);

            setisValid(true);
        } else {
            setErrorMessage(t('DeviceBulkUpload:EmptyFile'));
            setisValid(false);
        }
    };
    const readExcel = (file: any) => {
        try {
            setInvalidTemplateFile(false);
            // eslint-disable-next-line consistent-return
            const promise = new Promise((resolve, reject) => {
                const fileReader = new FileReader();

                if (!file) {
                    return setisValid(false);
                }
                fileReader.readAsArrayBuffer(file);

                fileReader.onload = (e) => {
                    const bufferArray = e?.target?.result ?? '';
                    const wb = XLSX.read(bufferArray, {
                        type: 'buffer',
                        cellDates: true,
                        cellStyles: true,
                        dateNF: Dates.Date,
                    });
                    const ws = wb.Sheets[wsname];
                    if (ws === undefined) {
                        setInvalidTemplateFile(true);
                        setshowInitialDialog(false);
                        setisValid(false);
                        return;
                    }
                    const data = XLSX.utils.sheet_to_json(ws);
                    resolve(data);
                };

                fileReader.onerror = (error) => {
                    reject(error);
                    setInvalidTemplateFile(true);
                    setshowInitialDialog(false);
                    setisValid(false);
                };
            });

            // eslint-disable-next-line consistent-return
            promise.then((d) => {
                MapDataToObj(d);
            });
        } catch (ex) {
            setInvalidTemplateFile(true);
            setshowInitialDialog(false);
            setisValid(false);
        }
    };

    // eslint-disable-next-line consistent-return
    const GetCellConfig = (): any[] | undefined => {
        const errorStyle = {
            // style
            fill: {
                patternType: 'solid',
                fgColor: { rgb: 'db4343' },
            },
            font: {
                name: 'Calibri',
                color: { rgb: 'f6f8fa' },
                bold: false,
                italic: false,
                underline: false,
            },
        };
        const standardStyle = {
            // style
            fill: {
                patternType: 'solid',
                fgColor: { rgb: '4472C4' },
            },
            font: {
                name: 'Calibri',
                color: { rgb: 'f6f8fa' },
                bold: false,
                italic: false,
                underline: false,
            },
        };
        const cell = {
            // create cell
            v: t('DeviceBulkUpload:ProccessingResultHeader'), // value
            s: errorStyle,
        };

        return [
            { v: t('DeviceBulkUpload:VendorNameHeader'), s: standardStyle },
            { v: t('DeviceBulkUpload:ModelNameHeader'), s: standardStyle },
            { v: t('DeviceBulkUpload:DeviceNameHeader'), s: standardStyle },
            { v: t('DeviceBulkUpload:StatusHeader'), s: standardStyle },
            { v: t('DeviceBulkUpload:DescENHeader'), s: standardStyle },
            { v: t('DeviceBulkUpload:TaxpayerBranchHeader'), s: standardStyle },
            { v: t('DeviceBulkUpload:SerialNumberHeader'), s: standardStyle },
            { v: t('DeviceBulkUpload:ActiveFromHeader'), s: standardStyle },
            { v: t('DeviceBulkUpload:ActiveToHeader'), s: standardStyle },
            cell,
        ];
    };
    const downloadExcel = (data: any, fileName: string) => {
        const newWB = XLSX.utils.book_new();
        const newWS = XLSX.utils.json_to_sheet(data, {
            cellStyles: true,
            cellDates: true,
        });
        const cellConfig = GetCellConfig();
        cellConfig?.map((cell, i) => {
            newWS[XLSX.utils.encode_cell({ c: i, r: 0 })] = cell;
        });

        const wscols = [
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
            { wch: 40 },
            { wch: 20 },
            { wch: 15 },
            { wch: 30 },
            { wch: 20 },
            { wch: 20 },
            { wch: 50 },
        ];

        newWS['!cols'] = wscols;

        XLSX.utils.book_append_sheet(newWB, newWS, wsname);
        const excelBuffer = XLSX.write(newWB, {
            bookType: 'xlsx',
            type: 'array',
            cellStyles: true,
            cellDates: true,
        });
        const blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
        saveAs(blob, fileName + EXCEL_EXTENSION);
    };
    const ValidateOnRecords = (records: CurrentDeviceDto[]): boolean => {
        if ((records.length ?? 0) === 0) {
            setErrorMessage(t('DeviceBulkUpload:EmptyFile'));
            return false;
        }
        if ((records.length ?? 0) > MaxRecordLen) {
            setErrorMessage(
                t('DeviceBulkUpload:ExceedMaxLen').replace(
                    '{0}',
                    MaxRecordLen.toString()
                )
            );
            return false;
        }

        const newRecords = records;
        for (let i = 0; i < newRecords.length; i += 1) {
            const element = newRecords[i];

            // eslint-disable-next-line no-restricted-globals
            if (
                element.activeFrom !== undefined &&
                !moment(element.activeFrom, DateFormat, true).isValid()
            ) {
                setErrorMessage(
                    t('DeviceBulkUpload:ErrorIn') +
                        t('DeviceBulkUpload:activeFrom') +
                        t('DeviceBulkUpload:AtRow') +
                        (i + 1) +
                        t('DeviceBulkUpload:CorrectDateFormat').replace(
                            '{0}',
                            DateFormat.toString()
                        )
                );
                return false;
            }
            // eslint-disable-next-line no-restricted-globals
            if (
                element.activeTo !== undefined &&
                !moment(element.activeTo, DateFormat, true).isValid()
            ) {
                setErrorMessage(
                    t('DeviceBulkUpload:ErrorIn') +
                        t('DeviceBulkUpload:activeTo') +
                        t('DeviceBulkUpload:AtRow') +
                        (i + 1) +
                        t('DeviceBulkUpload:CorrectDateFormat').replace(
                            '{0}',
                            DateFormat.toString()
                        )
                );
                return false;
            }
        }

        return true;
    };
    const FormatResponseAfterProccessData = (): any => {
        const resDataFile: any = [];
        let currentData: any = [];

        currentData = devices;
        rejectedDevices?.map((record, i) => {
            const index = record.index ?? 0;
            const currentDevice = currentData[index];
            // eslint-disable-next-line no-param-reassign
            const errorsList = rejectedDevices[i]?.errors?.map(
                (p) => p.message
            );
            currentDevice.ProccessingResult = errorsList?.join(', ');
            currentDevice.activeFrom = UIHelpers.getDateFormattedstr(
                currentDevice.activeFrom?.toString(),
                DateFormat
            );
            currentDevice.activeTo =
                currentDevice.activeTo === undefined
                    ? undefined
                    : UIHelpers.getDateFormattedstr(
                          currentDevice.activeTo?.toString(),
                          DateFormat
                      );

            delete currentDevice.credentialExpiryDate;
            if (currentDevice) {
                const customDevice = new ResponseCurrentDeviceDto();
                customDevice.vendorName = currentDevice.vendorName;
                customDevice.modelName = currentDevice.modelName;
                customDevice.name = currentDevice.name;
                customDevice.status = currentDevice.status;
                customDevice.description = currentDevice.description;
                customDevice.branchNumber = currentDevice.branchNumber;
                customDevice.serialNumber = currentDevice.serialNumber;
                customDevice.activeFrom = currentDevice.activeFrom;
                customDevice.activeTo = currentDevice.activeTo;
                customDevice.ProccessingResult =
                    currentDevice.ProccessingResult;
                resDataFile.push(customDevice);
            }
        });

        return resDataFile;
    };
    const GetInitialTemplateFileName = () => {
        let FileName = '';
        FileName = t('DeviceBulkUpload:DevicesBulkTemplateName');
        return FileName;
    };
    const DownloadInitialTemplateFile = () => {
        const FileName = `${GetInitialTemplateFileName()}`;
        UIHelpers.ExportFile(
            `./Templates/${FileName}.xlsx`,
            EXCEL_TYPE,
            FileName
        );
    };

    const filterDevicesList = (
        devicesList: CurrentDeviceDto[],
        invalidDevicesList?: InvalidDeviceDto[]
    ): CurrentDeviceDto[] => {
        let newDevices: CurrentDeviceDto[] = [...devicesList];

        if (invalidDevicesList && invalidDevicesList?.length > 0) {
            for (let index = 0; index < invalidDevicesList.length; index += 1) {
                const invalidDevice = invalidDevicesList[index];
                newDevices = newDevices.filter(
                    (d) => d.serialNumber !== invalidDevice.device?.serialNumber
                );
            }
        }
        return newDevices;
    };

    const checkPosSerialNumber = async (devicesList: CurrentDeviceDto[]) => {
        const posDevicesList: DeviceKeyDto[] = [];
        for (let i = 0; i < devicesList.length; i += 1) {
            const device = devicesList[i];
            posDevicesList.push(
                new DeviceKeyDto({
                    activeFrom: device.activeFrom,
                    modelName: device.modelName,
                    vendorName: device.vendorName,
                    serialNumber: device.serialNumber,
                })
            );
        }
        let response;
        try {
            const client = ServiceCreator.getPosManagementPublicClient();
            response = await client.validateDevices(posDevicesList);
            return response.invalidDevices;
        } catch (error) {
            const invalidPosDevicesList: InvalidDeviceDto[] = [];
            for (let i = 0; i < devicesList.length; i += 1) {
                const device = devicesList[i];
                invalidPosDevicesList.push(
                    new InvalidDeviceDto({
                        device: new DeviceKeyModel({
                            activeFrom: device.activeFrom,
                            modelName: device.modelName,
                            vendorName: device.vendorName,
                            serialNumber: device.serialNumber,
                        }),
                        index: i,
                        errors: [
                            new ValidationError({
                                message: error.response.message,
                            }),
                        ],
                    })
                );
            }
            return invalidPosDevicesList;
        }
    };

    const collectAllReturnedErrors = (
        rejectedDevicesFromPos: InvalidDeviceDto[],
        rejectedDevicesFromB2C: CurrentRejectedDeviceDto[]
    ) => {
        let allRejectedDevices: any[] = [];
        if (rejectedDevicesFromB2C.length > 0) {
            allRejectedDevices = [
                ...allRejectedDevices,
                ...rejectedDevicesFromB2C,
            ];
        }
        if (rejectedDevicesFromPos.length > 0) {
            allRejectedDevices = [
                ...allRejectedDevices,
                ...rejectedDevicesFromPos,
            ];
        }
        setRejectedDevices(allRejectedDevices);
    };

    const sendData = async () => {
        setShowProgress(true);
        setInvalidTemplateFile(false);
        try {
            if (!ValidateOnRecords(devices ?? []) ) {
                setshowInitialDialog(true);
                setShowProgress(false);
                return;
            }
            const client = ServiceCreator.getPosManagementPublicClient();
            let filterResult: CurrentDeviceDto[] = [];
            let inValidPosDevices: InvalidDeviceDto[] = [];
            if (systemConfiguration && devices) {
                inValidPosDevices = (await checkPosSerialNumber(devices)) ?? [];
                filterResult =
                    filterDevicesList(devices, inValidPosDevices) ?? [];
            }
            const listLength = systemConfiguration
                ? filterResult.length ?? 0
                : (devices ?? []).length ?? 0;
            const list = systemConfiguration
                ? filterResult ?? []
                : devices ?? [];
           

            if (listLength > 0) {
                const request = list ?? [];
                const response = await client.addDevices(request);
                collectAllReturnedErrors(
                    inValidPosDevices ?? [],
                    response.rejectedDevices ?? []
                );
                setPassedDevicesCount(response.acceptedDevices?.length ?? 0);
            }
            if (listLength === 0 && inValidPosDevices.length > 0) {
                collectAllReturnedErrors(inValidPosDevices ?? [], []);
            }
            if (inValidPosDevices.length === 0 && listLength === 0) {
                setInvalidTemplateFile(true);
            }
            setshowInitialDialog(false);
            setShowProgress(false);
        } catch (ex) {
            setShowProgress(false);
            setErrors(UIHelpers.GetErrors(ex));
            setshowInitialDialog(false);
            setInvalidTemplateFile(true);
        }
    };
    const GetFileName = () => {
        let FileName = '';
        FileName = 'DevicesBulkResponseTemplate';
        FileName = t('DeviceBulkUpload:DevicesBulkResponseTemplate');

        return FileName;
    };
    const onDialogClosed = () => {
        onStartProcessing('', true);
        setHiddenDialog(true);
    };
    const onDialogCancelClicked = async () => {
        onStartProcessing('', true);
        setHiddenDialog(true);
    };
    const onDownloadErrorFileClicked = async () => {
        const FileName = GetFileName();
        downloadExcel(FormatResponseAfterProccessData(), FileName);
    };
    const onDialogSaveClicked = async () => {
        sendData();
    };
    const onTryAgainClicked = () => {
        setshowInitialDialog(true);
        setInvalidTemplateFile(false);
    };
    const IsSomePassedSomeFailed = () => {
        return passedDevicesCount > 0 && (rejectedDevices?.length ?? 0) > 0;
    };
    const IsAllSuccessfullyProccessed = () => {
        return passedDevicesCount > 0 && (rejectedDevices?.length ?? 0) === 0;
    };
    const IsAllFailed = () => {
        return passedDevicesCount === 0 && (rejectedDevices?.length ?? 0) > 0;
    };
    const GetPassedCount = () => {
        let passedCount = 0;
        passedCount = passedDevicesCount;
        return passedCount;
    };
    const GetFailedCount = () => {
        let failedCount = 0;
        failedCount = rejectedDevices?.length ?? 0;
        return failedCount;
    };
    const GetRowsCount = () => {
        let rowsCount = 0;
        rowsCount = devices?.length ?? 0;
        return rowsCount;
    };
    const GetRowOrRows = (count: number): string => {
        if (count === 1) return ` ${t('row')} `;
        return ` ${t('rows')} `;
    };
    const modelProps = {
        isBlocking: !invalidTemplateFile,
    };
    const getSystemConfiguration = async () => {
        const client = ServiceCreator.getPosManagementPublicClient();
        const response = await client.getPosConfig();
        setSystemConfiguration(response.allowTrustedSystemCertification);
    };

    useEffect(() => {
        getSystemConfiguration();
    }, []);
    return (
        <Dialog
            containerClassName="RegisterBulkDialog"
            hidden={hiddenDialog}
            onDismiss={() => onDialogClosed()}
            maxWidth={500}
            title={GetTitle()}
            modalProps={modelProps}
        >
            <div className="DialogContainer">
                {/* 1) first Dialog initialy */}
                {showInitialDialog && (
                    <>
                        <div className="BodyContent">
                            <ol>
                                <li>
                                    <Label>
                                        {' '}
                                        {t('DeviceBulkUpload:DownloadTemplate')}
                                    </Label>
                                    <div className="DownloadTemp">
                                        <Icon iconName="ExcelDocument" />
                                        <Label className="existingCode">
                                            {existingTempFileInfo.name}
                                        </Label>
                                        <Label
                                            className="downloadFile"
                                            title={t(
                                                'DeviceBulkUpload:Download'
                                            )}
                                            onClick={() => {
                                                DownloadInitialTemplateFile();
                                                setTimeout(() => {
                                                    const newTab = window.open(
                                                        '',
                                                        '_blank'
                                                    );
                                                    newTab?.close();
                                                }, 300);
                                            }}
                                        >
                                            {t('DeviceBulkUpload:Download')}
                                        </Label>
                                    </div>
                                </li>
                                <li>
                                    <Label required>
                                        {t('DeviceBulkUpload:UploadFile')}
                                    </Label>
                                    <FileSelector
                                        labels={{
                                            selectFile: t('common:BrowseFile'),
                                            chooseAnotherFile: t(
                                                'common:ChooseAnother'
                                            ),
                                            unSelectFile: t('common:UnSelect'),
                                            // viewFile: t('common:view'),
                                            // downloadFile: t('common:download'),
                                        }}
                                        mode={FileSelectorMode.standard}
                                        extensionFilter=".xlsx"
                                        onSelectFile={(
                                            selectedFile: FileInfo
                                        ) => {
                                            setErrorMessage('');
                                            return readExcel(selectedFile.file);
                                        }}
                                        onUnSelectFile={()=>{
                                            setErrorMessage('');
                                            return readExcel(undefined);
                                        }}
                                        // errorMessage={ErrorMessage}
                                    />
                                    {ErrorMessage !== '' && (
                                        <span className="ErrorMessage">
                                            {ErrorMessage}
                                        </span>
                                    )}
                                </li>
                            </ol>
                        </div>
                        <div className="Buttons">
                            <ActionButton
                                className="btn-cancel"
                                onClick={onDialogCancelClicked}
                                iconProps={cancelIcon}
                                text={t('DeviceBulkUpload:cancel')}
                            />
                            <PrimaryButton
                                className="btn-save"
                                onClick={onDialogSaveClicked}
                                iconProps={playResume}
                                text={t('DeviceBulkUpload:btnStartProcessing')}
                                disabled={!isValid}
                            />
                        </div>
                        <div className="note">
                            <MessageBar
                                messageBarType={MessageBarType.info}
                                isMultiline
                            >
                                <div>
                                    <span className="bold">
                                        {t('DeviceBulkUpload:BulkNote')}
                                    </span>
                                    <span>
                                        {t(
                                            'DeviceBulkUpload:BulkrequiredRegistration1'
                                        )}{' '}
                                        <span className="bold">
                                            {t(
                                                'DeviceBulkUpload:BulkrequiredRegistration2'
                                            ).replace(
                                                '{0}',
                                                MaxRecordLen.toString()
                                            )}
                                        </span>
                                    </span>
                                </div>
                            </MessageBar>
                        </div>
                    </>
                )}

                {/* 2) some passed some failed */}
                {IsSomePassedSomeFailed() && (
                    <div className="content-passedFailed">
                        <Label className="bold Completed">
                            {t('DeviceBulkUpload:SuccessfullyCompleted')}{' '}
                            <span className="totalCounts">{`(${t(
                                'total'
                            )} ${GetRowsCount()} ${GetRowOrRows(
                                GetRowsCount()
                            )})`}</span>
                        </Label>
                        <div className="successRowContent">
                            <Icon
                                iconName="CompletedSolid"
                                color="green"
                                className="FileColor"
                            />
                            <Label>
                                <span className="bold">
                                    {GetPassedCount() +
                                        GetRowOrRows(GetPassedCount()) +
                                        t('DeviceBulkUpload:CompeletedTitle')}
                                </span>{' '}
                                <div className="contentRow">
                                    {t('DeviceBulkUpload:CompeletedDesc')}
                                    <br />
                                    {t('DeviceBulkUpload:CompeletedDesc2')}
                                </div>
                            </Label>
                        </div>
                        <div className="faildRowContent">
                            <Icon
                                iconName="ErrorBadge"
                                color="red"
                                className="ErrorFileColor"
                            />
                            <Label>
                                <span className="bold">
                                    {GetFailedCount() +
                                        GetRowOrRows(GetFailedCount()) +
                                        t(
                                            'DeviceBulkUpload:NotCompeletedTitle'
                                        )}
                                </span>{' '}
                                <div className="contentRow">
                                    {t('DeviceBulkUpload:NotCompeletedDesc')}
                                </div>
                            </Label>
                        </div>
                        <div className="btn-download">
                            <PrimaryButton
                                onClick={() => onDownloadErrorFileClicked()}
                                iconProps={downloadIcon}
                                text={t('DeviceBulkUpload:btnDownload')}
                            />
                        </div>

                        <Label className="NotCompeletedNote">
                            {t('DeviceBulkUpload:NotCompeletedNote')}
                        </Label>
                        <div className="btn-close">
                            <ActionButton
                                onClick={onDialogCancelClicked}
                                text={t('DeviceBulkUpload:close')}
                            />
                        </div>
                    </div>
                )}

                {/* 3) all SuccessfullyCompleted */}
                {IsAllSuccessfullyProccessed() && (
                    <div className="content-SuccessfullyCompleted">
                        <Label className="bold Completed">
                            {t('DeviceBulkUpload:SuccessfullyCompleted')}{' '}
                            <span className="totalCounts">{`(${t(
                                'total'
                            )} ${GetRowsCount()} ${GetRowOrRows(
                                GetRowsCount()
                            )})`}</span>
                        </Label>
                        <div className="successRowContent">
                            <Icon
                                iconName="CompletedSolid"
                                color="green"
                                className="FileColor"
                            />
                            <Label>
                                <span className="bold">
                                    {GetPassedCount() +
                                        GetRowOrRows(GetPassedCount()) +
                                        t('DeviceBulkUpload:CompeletedTitle')}
                                </span>{' '}
                                <div className="contentRow">
                                    {t('DeviceBulkUpload:CompeletedDesc')}{' '}
                                    <br />
                                    {t('DeviceBulkUpload:CompeletedDesc2')}
                                </div>
                            </Label>
                        </div>
                        <div className="btn-close">
                            <ActionButton
                                onClick={onDialogCancelClicked}
                                text={t('DeviceBulkUpload:close')}
                            />
                        </div>
                    </div>
                )}

                {/* 4) all failed */}
                {IsAllFailed() && (
                    <div className="allFailed">
                        <Label className="bold Completed">
                            {t('DeviceBulkUpload:SuccessfullyCompleted')}{' '}
                            <span>{`(${t(
                                'total'
                            )} ${GetRowsCount()} ${GetRowOrRows(
                                GetRowsCount()
                            )})`}</span>
                        </Label>
                        <div className="faildRowContent">
                            <Icon
                                iconName="ErrorBadge"
                                color="red"
                                className="ErrorFileColor"
                            />
                            <Label>
                                <span className="bold">
                                    {GetFailedCount() +
                                        GetRowOrRows(GetFailedCount()) +
                                        t(
                                            'DeviceBulkUpload:NotCompeletedTitle'
                                        )}
                                </span>{' '}
                                <div className="contentRow">
                                    {t('DeviceBulkUpload:NotCompeletedDesc')}
                                </div>
                            </Label>
                        </div>
                        <div className="btn-download">
                            <PrimaryButton
                                onClick={() => onDownloadErrorFileClicked()}
                                iconProps={downloadIcon}
                                text={t('DeviceBulkUpload:btnDownload')}
                            />
                        </div>

                        <Label className="NotCompeletedNote">
                            {t('DeviceBulkUpload:NotCompeletedNote')}
                        </Label>
                        <div className="btn-close">
                            <ActionButton
                                onClick={onDialogCancelClicked}
                                text={t('DeviceBulkUpload:close')}
                            />
                        </div>
                    </div>
                )}
                {/*  5) invalid templateFile */}
                {invalidTemplateFile && (
                    <div className="invalidTemplateFile">
                        <Label className="bold Completed">
                            {t('DeviceBulkUpload:CouldNotProccessFile')}
                        </Label>
                        <div className="faildRowContent">
                            <Icon
                                iconName="ErrorBadge"
                                color="red"
                                className="ErrorFileColor"
                            />
                            <Label>
                                <span className="bold">
                                    {t('DeviceBulkUpload:InvalidTemplate')}
                                </span>{' '}
                                <div className="contentRow">
                                    {t('DeviceBulkUpload:InvalidTemplateDesc')}
                                </div>
                            </Label>
                        </div>
                        <div className="btn-download">
                            <PrimaryButton
                                onClick={() => DownloadInitialTemplateFile()}
                                iconProps={downloadIcon}
                                text={t('DeviceBulkUpload:btnDownloadTemplate')}
                            />
                        </div>
                        <div className="btns-invalidTemplate">
                            <ActionButton
                                className="btn-tryAgain"
                                onClick={onTryAgainClicked}
                                text={t('DeviceBulkUpload:btnTryAgain')}
                            />
                            <ActionButton
                                className="btn-close"
                                onClick={onDialogCancelClicked}
                                text={t('DeviceBulkUpload:close')}
                            />
                        </div>
                    </div>
                )}
            </div>

            {/* ProgressBar */}
            {showProgress && (
                <OriginalDialog hidden={!showProgress}>
                    <div className="LoadingPanel">
                        <div className="LoadingItem">
                            <ProgressIndicator
                                label={t('DeviceBulkUpload:InProgress')}
                                description={t(
                                    'DeviceBulkUpload:InProgressDesc'
                                )}
                            />
                        </div>
                    </div>
                </OriginalDialog>
            )}
        </Dialog>
    );
};
